import { render } from "./CustomerCharges.vue?vue&type=template&id=5235fae8"
import script from "./CustomerCharges.vue?vue&type=script&lang=js"
export * from "./CustomerCharges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__